// src/context/AuthProvider.js
import React, { createContext, useState, useEffect, useContext } from "react";
import axios from "axios";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const { data } = await axios.get("/api/user");
        if (isMounted) {
          const resolvedUser = data.user || null;

          // Seed localStorage with saved layer preferences before isLoading=false
          // so NavBar reads the correct value on mount.
          if (resolvedUser?.sub) {
            try {
              const { data: prefs } = await axios.get("/api/user/layer-preferences");
              const val = prefs?.layerPreferences;
              if (typeof val === "string" && val.length > 0) {
                localStorage.setItem("markerFilters", val);
              }
            } catch (prefsErr) {
              console.warn("Could not load layer preferences:", prefsErr);
            }
          }

          setUser(resolvedUser);
        }
      } catch (err) {
        console.error("Error fetching user auth:", err);
        if (isMounted) {
          setUser(null);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    })();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <AuthContext.Provider value={{ user, isLoading, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

// A convenience hook to use the AuthContext
export function useAuth() {
  return useContext(AuthContext);
}
